import {PackageURL} from "packageurl-js";

export function packageUrlSupportedByDepsDev(purl?: PackageURL) {
    if (purl === undefined || purl == null) {
        return false;
    }

    return ["go", "rubygems", "npm", "cargo", "maven", "pypi", "nuget"].includes(purl.type?.toLowerCase());
}

export function packageUrlToOsiUrl(purl: PackageURL) {
    if (purl.type === 'maven') {
        return `https://deps.dev/maven/${encodeURIComponent(`${purl.namespace}:${purl.name}`)}/${encodeURIComponent(purl.version)}`;
    } else {
        return `https://deps.dev/${purl.type}/${encodeURIComponent(`${(purl.namespace) ? purl.namespace + '/' : ''}${purl.name}`)}/${encodeURIComponent(purl.version)}`;
    }
}
